
import axios from 'axios';
import ctrls from '../../controls/_index.js';
import modal from '../../modal.vue';
import formdataUtil from '../../util-formdata.js';
import { has, getFieldValue } from '../../utils';
import childNavMixin from './../../mixins/child-nav-mixin.js';

import flagVisible from '../../controls/flag_visible.vue';

import { PropType } from 'vue';
import { UarmArm, ListMetaItem, UarmListItem } from '@uarmSrc/types';
import { UarmListTreeLevel } from '@uarmSrc/util-tree';

export default {
	name: 'listitem', // это имя будет использовано для рекурсивного вызова!
	data() {
		// Данные полей родительского АРМа для проброса в дочерний через попап - PIRS-2-11881
		const modalParentFields = [];
		for (const col of this.$props.listMeta) {
			if (col.ctrlParams.nameInPopupChild) {
				modalParentFields.push({
					name: col.ctrlParams.nameInPopupChild,
					value: this.$props.item[col.dbcolname],
					dbcolname: col.dbcolname,
				});
			}
		}

		return {
			modalParentFields,
			has,
			armId: this.$props.armMeta.id,
			errText: '',
			errTextModalVisible: false,
			recordRemovePending: false,
			recordSavePending: false,
			EXT_removeChboxState: false, // состояние чекбокса "удалить". EXT значит что меняется снаружи!
			itemNotEdited: true,
			isNotPopup: !this.$props.pick_type,
			inWindowVisible: false,
			isDisabledBtnCopyRecord: false,
		};
	},
	props: {
		armMeta: {
			// внимание! этот объект должен быть иммутабельным, потому что они один на всех
			type: Object as PropType<UarmArm>,
		},
		listMeta: {
			// внимание! этот массив и его элементы должны быть иммутабельными, потому что они одни на всех
			type: Array as PropType<ListMetaItem[]>,
		},
		item: {
			type: Object as PropType<UarmListItem>,
		},
		pick_type: {
			// если режим выбора, то single или multi (одиночный/множественный). Если нормальный режим, то пусто
			type: String as PropType<'single' | 'multi' | undefined>,
		},
		item_is_picked: {
			// признак того что запись в списке выбрана
			type: Boolean,
			default: false,
		},
		show_edit_btn: {
			type: Boolean,
			default: false,
		},
		manualsave_chbox_checked: {
			type: Boolean,
			default: false,
		},
		force_disable_controls: {
			type: Boolean,
			default: false,
		},
		dynamicFieldGroups: {
			type: Array,
		},
		tableListRowColors: {
			type: Array,
			default: () => [],
		},
		siteId: {
			type: [Number, String],
			required: true,
		},
		treeViewLvl: {
			type: Object as PropType<TreeViewLvlType>,
		},
	},
	computed: {
		c_actionPending: function () {
			return this.$data.recordRemovePending || this.$data.recordSavePending || this.$props.force_disable_controls;
		},
		c_treeKidsCollapseExpandClass: function () {
			// const mainClassName = this.c_itemExpandable ? 'glyphicon-plus' : 'glyphicon-minus';
			const { item }: { item: UarmListItem } = this.$props;

			let mainClassName: string = '';
			if (item.ITEM_KIDS_IS_FETCHING) mainClassName = 'glyphicon-refresh';
			else mainClassName = this.c_itemExpandable ? 'glyphicon-chevron-right' : 'glyphicon-chevron-up';

			const colorClassName = item.ITEM_HAS_KIDS_TO_BE_FETCHED ? 'load-kids-btn' : ''; // для поиска: .load-kids-btn
			return `glyphicon ${mainClassName} ${colorClassName}`;
		},
		c_treeKidsCollapseExpandTitle: function () {
			let title: string = '';
			const { item, armMeta }: { item: UarmListItem; armMeta: UarmArm } = this.$props;
			if (!item.kid_count) title = 'Дочерние записи отсутствуют';
			else if (armMeta.isTreeViewByLevel && item.ITEM_HAS_KIDS_TO_BE_FETCHED)
				title = 'Загрузить непосредственные дочерние записи';
			else if (item.ITEM_KIDS_COLLAPSED) title = 'Развернуть все загруженные дочерние записи';
			else if (!item.ITEM_KIDS_COLLAPSED) title = 'Свернуть все загруженные дочерние записи';
			return title;
		},
		c_itemExpandable() {
			const { item, armMeta }: { item: UarmListItem; armMeta: UarmArm } = this.$props;
			const itemExpandable =
				item.ITEM_KIDS_COLLAPSED ||
				!item.kid_count || // у бездетных всегда свернуть (просто дизейблд)
				item.ITEM_HAS_KIDS_TO_BE_FETCHED;
			return !!itemExpandable;
		},
		/* c_kidsNotYetFetched: function () {
			const { treeViewLvl, item, armMeta }: { armMeta: UarmArm; treeViewLvl: TreeViewLvlType; item: UarmListItem } = this.$props;
			if (item.ITEM_ID === 1021 || this.armId === 888811) {
				console.log(`[${item.ITEM_ID}] c_kidsNotYetFetched! `, `tree_level = `, item.tree_level, `; maxPossible`, treeViewLvl.maxPossible);
			}
			return !(armMeta.isTreeViewByLevel && item.kid_count && item.tree_level === treeViewLvl.maxPossible - 1);
		}, */
		c_manualsave_title: function () {
			if (this.$data.itemNotEdited) {
				return 'Данная запись не редактировалась';
			}
			if (this.$props.manualsave_chbox_checked) {
				return 'При нажатии кнопки Изменить данная запись будет изменена';
			} else {
				return 'При нажатии кнопки Изменить данная запись НЕ будет изменена';
			}
		},
		c_manualsave_chbox_checked: {
			get: function () {
				return this.$props.manualsave_chbox_checked;
			},
			set: function (newVal) {
				var recordId = this.$props.item.ITEM_ID;
				var submitArgument;
				if (newVal) {
					submitArgument = this.getSubmitArgument(true);
					submitArgument._listItemComponentRef = this;
				}
				this.$emit('e_manualsave_queue_update', recordId, submitArgument);
			},
		},
		isDynamicFields() {
			return has(this.armMeta, 'isDynamicFields') && this.armMeta.isDynamicFields === true;
		},
		isMultipleArm() {
			return has(this.armMeta, 'isMultipleArm') && this.armMeta.isMultipleArm === true;
		},
		dynamicFieldGroup() {
			const field = this.armMeta.fields.find((f) => has(f, 'isDynamicFieldGroup') && f.isDynamicFieldGroup === true);
			return this.isDynamicFields && field ? this.item[field.dbcolname] : null;
		},
		isNotDeletableField() {
			let isNotDeletable = false;
			const field = this.armMeta.fields.find((f) => has(f, 'isDynamicFieldGroup') && f.isDynamicFieldGroup === true);
			if (this.isDynamicFields && field) {
				const group = this.dynamicFieldGroups.find((g) => String(g.id) === String(this.item[field.dbcolname]));
				isNotDeletable = group && has(group, 'isNotDeletable') ? group['isNotDeletable'] === true : false;
			}

			return isNotDeletable;
		},
		childArms() {
			return this.armMeta.childArms.filter((c) => this.checkChildArm(c));
		},
		popupChildArms() {
			// Дочерние АРМы, открывающиеся в попапе
			return this.armMeta.childArms.filter(({ openInPopup, customOpen }) => openInPopup && !customOpen);
		},
		backgroundColor() {
			let color = '';

			if (this.tableListRowColors && this.tableListRowColors.length) {
				const rowColor = this.tableListRowColors.find(
					(c) => c['items'] && Array.isArray(c['items']) && c['items'].includes(this.item.ITEM_ID),
				);

				if (rowColor) {
					const { color } = rowColor;
					return color;
				}
			}

			return color;
		},
	},
	watch: {
		c_actionPending: function (newVal, oldVal) {
			if (!oldVal && newVal) {
				this.$data.errText = '';
			}
		},
		errText: function (newVal, oldVal) {
			if (!oldVal && newVal) {
				this.errTextModalVisible = true;
			}
		},
		EXT_removeChboxState: function (v) {
			this.$emit('remove_chbox_toggle', this.$props.item, v);
		},
	},
	components: Object.assign({ modal }, ctrls, { flagVisible }),
	mounted() {
		this.gotoPopupArm = this.gotoPopupArm.bind(this);
		const item: UarmListItem = this.$props.item;
		const armMeta: UarmArm = this.$props.armMeta;
		const idPathStored = UarmListTreeLevel.getIdPathValue(armMeta.id);
		const idPathStoredArray = idPathStored?.split?.('!')?.filter?.(Boolean);
		const idPathStoredIncludesItem = idPathStoredArray?.includes?.(String(item.ITEM_ID));
		const idPathStoredLastIndex = idPathStoredArray?.lastIndexOf?.(String(item.ITEM_ID));
		// здесь тоже!!!!!!!!!!!!!!!!!!!!!!!!!!!
		if (idPathStoredIncludesItem && idPathStoredLastIndex !== idPathStoredArray?.length - 1) {
			console.error(`mounted! item.ITEM_ID=${item.ITEM_ID} !!!!!!!!!!!! написать коммент 1, почему так !!!!!!!!!!`);

			this.treeKidsCollapseExpand();
		}

		// PIRS-2-12350 - заказчику потребовалась логика открытия из недр кастомного шаблона
		for (const childPopupOpener of this.$el.querySelectorAll('[data-popup-arm]')) {
			childPopupOpener.addEventListener('click', this.gotoPopupArm);
		}
	},
	beforeDestroy() {
		for (const childPopupOpener of this.$el.querySelectorAll('[data-popup-arm]')) {
			childPopupOpener.removeEventListener('click', this.gotoPopupArm);
		}
	},
	methods: {
		copyRecord(recordId) {
			if (!recordId) {
				console.error('У записи нет ID');
				return;
			}
			this.isDisabledBtnCopyRecord = true;
			this.$notify({ type: 'info', text: 'Процесс копирования начался. Перегрузите страницу через 1м' });
			axios
				.post(`/api/uarm-record-cloner/clone/${this.$props.siteId}/${this.armId}/${recordId}`)
				.then(() => this.$notify({ type: 'success', text: 'Процесс копирования завершен. Перегрузите страницу.' }))
				.catch(() => this.$notify({ type: 'error', text: 'Копирование не удалось. Возникла ошибка' }))
				.finally(() => (this.isDisabledBtnCopyRecord = false));
		},
		windowVisibility: function () {
			if (!this.inWindowVisible) {
				this.inWindowVisible = true;
			}
		},
		tdStyle: function (f_i) {
			if (this.isTreeShiftedCol(f_i)) {
				return {
					'padding-left': this.getTreeShiftValue(),
					width: 'auto',
				};
			} else {
				return '';
			}
		},
		/** Нажатие на свернуть или развернуть */
		treeKidsCollapseExpand: function () {
			const item: UarmListItem = this.$props.item;
			/** false - до клика был свернуть, true - до клика был развернуть */
			const newChildrenCollapsedValue = !item.ITEM_KIDS_COLLAPSED;
			// вообще место newChildrenCollapsedValue - тоже в листе, айтем то доступен там
			this.$emit('e_tree_children_collapsed', newChildrenCollapsedValue);
		},
		itemPick: function () {
			this.$emit('e_item_select', this.item);
		},
		getTreeShiftValue: function () {
			var tree_level = this.$props.item.tree_level || 1;
			return (tree_level - 1) * 25 - 7 + 20 + 'px'; // ОМГ
		},
		// Обработчик клика по ссылке (контрол Статик с признаком isLink)
		onStaticLinkClick: function () {
			if (this.pick_type) {
				// в попапе выбираем запись
				this.itemPick();
			} else {
				// в нормальном арме - переходим в карточку
				this.$emit('e_goToCard', this.item);
			}
		},
		isTreeShiftedCol: function (colIndex) {
			const armMeta: UarmArm = this.$props.armMeta;
			return colIndex === 0 && armMeta.isTreeView && this.$props.item.tree_level > 1;
		},
		onSaveEvent: function () {
			const armMeta: UarmArm = this.$props.armMeta;
			const item: UarmListItem = this.$props.item;
			if (!armMeta.isEditable) {
				return; // для нередактируемых АРМ сохранение не случается
			}
			this.$data.itemNotEdited = false;

			// Если сохранение вручную - отправляем объект-аргумент наверх (в компьютеде c_manualsave_chbox_checked)
			// чтобы он был передан formdataUtil_doSubmit по нажатию кнопки Изменить
			if (armMeta.isManualListSaving) {
				this.c_manualsave_chbox_checked = true;
			}
			// если автосохранение, то сразу отправляем данные на сервер
			else {
				this.formdataUtil_doSubmit(this.getSubmitArgument());
			}
		},
		recordRemove: function () {},
		gotoChildArm: function (childArmObj) {
			// Вызов childNav_toChild() у родителя (функция из миксина)
			this.$emit('child_arm_navigate', {
				childArmObj,
				parentRecordData: this.$props.item,
				isCard: false,
			});
		},
		gotoPopupArm: function (evt) {
			evt.preventDefault();

			// Оповещение списка о том, что надо открыть дочерний АРМ в попапе
			this.$root.$emit('open-popup-child-arm', this.$props.item.ITEM_ID, this.modalParentFields);
		},
		dismissErrorModal: function () {
			this.$data.errTextModalVisible = false;
			this.$data.errText = '';
		},
		// у всплывающих окон редактирование отключено вот таким способом:
		// для всех кроме радио (там можно ридонли сделать) и фала ( PIRS2018-2968 ) включен статик
		// по уму надо сохранить контролы, все равно в них передается is_disabled
		getComponentCode: function (f) {
			const forceStatic = this.isForceStaticField(f);
			return forceStatic ? 'text_static' : f.ctrlCode;
		},
		isForceStaticField(f) {
			const isPublishType = f.ctrlCode === 'dropdown' && f.ctrlParams.isPublishType; // PIRS2018-2376
			const isDiffCtrl = f.ctrlCode === 'special_controls' && f.ctrlParams.spс_сomponent === 'spc_diff_checkers';
			return (
				this.$data.isNotPopup === false &&
				f.ctrlCode !== 'flag' &&
				f.ctrlCode !== 'file_upload' &&
				!isPublishType &&
				!isDiffCtrl
			);
		},
		/**
		 * Три вида сохранения записи:
		 * - карточка: p_card.vue
		 * - список: поэлементное сохранение (дефолтное, по изменению контрола) p_list.vue
		 * - список: общее сохранения (с чекбоксами, по нажатию кнопки) ListItem.vue
		 */
		getSubmitArgument: function () {
			const armMeta: UarmArm = this.$props.armMeta;
			var vm = this;
			// Копируем массив полей чтобы не мутировать общий listMeta, иначе при сохранении
			// нескольких записей с кнопкой "Изменить" уходят одинаковые значения.
			// Копирование через slice() не подходит, потому что элементы массива не копируются, на них остаются ссылки.
			// Можно было бы копировать сразу из пропса при создании компонента, но это не экономично, придется помнить.
			type ListMetaItemWithVal = ListMetaItem & { value: any };
			var listMetaWithValues: ListMetaItemWithVal[] = JSON.parse(JSON.stringify(this.$props.listMeta));
			for (var i = 0; i < listMetaWithValues.length; i++) {
				listMetaWithValues[i].value = vm.$props.item[listMetaWithValues[i].dbcolname];
			}
			var recordId = vm.$props.item.ITEM_ID;
			return {
				armId: vm.$data.armId,
				mode: 'update',
				fieldList: listMetaWithValues,
				recordId: recordId,
				successCallback: function (data) {
					vm.$notify({
						type: 'success',
						text: 'Запись ID=' + vm.$props.item.ITEM_ID + ' успешно сохранена',
					});

					if (armMeta.isTreeViewByLevel) {
						console.error(`>>>>>  МЫ ЧТО-ТО сохранили в слоистый АРМ, надо сохранить id_path в сессию`);
						const savedDataFields = data?.data;
						console.log('получили это:', getFieldValue(savedDataFields.records[0]?.fields, 'id_path'));
						const idPathNew = getFieldValue(savedDataFields.records[0]?.fields, 'id_path');

						UarmListTreeLevel.setIdPathValue(vm.$data.armId, idPathNew as string);
					}
					if (armMeta.isForceListReloading) {
						vm.$emit('e_reload');
					}
				},
				armState: this.childNav_getArmState(listMetaWithValues, this.$props.item),
			};
		},
		EXT_setRecordSavePending: function (newVal) {
			// EXT_ означает что дергается снаружи! formdataUtil_doSubmit
			this.$data.recordSavePending = !!newVal;
		},
		checkChildArm(childArm) {
			// Не показываем поле, если у нас выбрана группа и у поля есть группа и выбранаая группа !== группы у поля
			// Не показываем поле, если у нас не выбрана группа, а у поля есть группа ( последнее или можно убрать )
			if (
				this.isDynamicFields &&
				((!!this.dynamicFieldGroup &&
					!!childArm['dynamicFieldGroup'] &&
					childArm['dynamicFieldGroup'].length &&
					childArm['dynamicFieldGroup'].includes(String(this.dynamicFieldGroup)) === false) ||
					(!this.dynamicFieldGroup && childArm['dynamicFieldGroup'] && childArm['dynamicFieldGroup'].length))
			) {
				return false;
			}

			// PIRS-2-11881 - в стандартный список не выводим АРМы, открывающиеся в popup-режиме
			// Также не выводим АРМы, для которых предусмотрен кастомный открывающийся элемент
			return !childArm.openInPopup && !childArm.customOpen;
		},
	},
	mixins: [formdataUtil.mixin, childNavMixin],
};

type TreeViewLvlType = Record<string, number>;
